import React from "react";
import { string } from "prop-types";

import HeaderNavLink from "../../../HeaderNavLink";

const AdvertiseLink = ({ advertise_url }) => (
  <HeaderNavLink aria-label="Advertise Link" href={advertise_url}>
    Advertise
  </HeaderNavLink>
);

AdvertiseLink.propTypes = { advertise_url: string.isRequired };

export default AdvertiseLink;
